import { IS_IOS } from '@/config/browserEnv';

const REVOKE_AUTO_LOAD_LINK = 150;

// On iOS all browsers (Safari, Chrome, etc.) share WebKit. The OS-level
// OfficeImportErrorDomain handler intercepts AIP/IRM-protected Office files
// at load time — in any tab, any window — and fails with error 912 because
// RMS authentication is not available in a browser context.
//
// Fetching the file as a blob and creating a same-origin blob: URL sidesteps
// this entirely: iOS never sees the remote URL or MIME type, and the 'download'
// attribute is honoured for same-origin URLs, so the file lands in Files.app.
// Falls back to window.location.href if the fetch fails (e.g. CORS mismatch).
const downloadFileOnIOS = (fileUrl: string, filename?: string): void => {
    fetch(fileUrl)
        .then((response) => response.blob())
        .then((blob) => {
            const blobUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.setAttribute('download', filename ?? '');
            document.body.appendChild(link);
            link.click();
            link.remove();
            setTimeout(() => URL.revokeObjectURL(blobUrl), REVOKE_AUTO_LOAD_LINK);
        })
        .catch(() => {
            window.location.href = fileUrl;
        });
};

const downloadFile = (fileUrl: string, filename?: string): void => {
    if (IS_IOS) {
        downloadFileOnIOS(fileUrl, filename);
        return;
    }

    const link = document.createElement('a');
    link.href = fileUrl;
    link.setAttribute('download', filename ?? '');
    link.setAttribute('target', '_blank');

    const clickHandler = (): void => {
        setTimeout(() => {
            URL.revokeObjectURL(fileUrl);
            link.remove();
        }, REVOKE_AUTO_LOAD_LINK);
    };

    link.addEventListener('click', clickHandler, false);
    link.click();
};

export default downloadFile;
